import React from 'react';
import './FScontent.css';

const FScontent = () => {
    return (
        <div className="FS-pgContent">
            <div className="FS-container">

                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Fabric Shade</h1>
                    <p className="FS-pg-S-title">2000 + pleasing and soothing Fabric Shades <br />
                        Callistus believes in creating amazing design in Window Blinds that matches every interior choices and types.<br />
                        Hence we have feature a wide range of 2000+ fabrics in various colors and textures.</p>
                </div>

                <div className="fs-row1 fs-rows">
                    <a className='r1-card1' href="#">
                        <img src="/Assets/FSimages/m1.webp" />
                        <h3>Grayson Blinds</h3>
                    </a>
                    <a className='r1-card2' href="#">
                        <img src="/Assets/FSimages/m2.webp" />
                        <h3>Meliso Blinds</h3>
                    </a>
                    <a className='r1-card3' href="#">
                        <img src="/Assets/FSimages/m3.webp" />
                        <h3>Dorren Blinds</h3>
                    </a>
                    <a className='r1-card4' href="#">
                        <img src="/Assets/FSimages/m4.webp" />
                        <h3>Sierra Blinds</h3>
                    </a>
                </div>

                <div className="fs-row2 fs-rows">
                    <h3>Colby Blinds</h3>
                    <div className="fs-r2-cards">
                        <a className='r2-card1' href="#">
                            <img src="/Assets/FSimages/h1.webp" />
                        </a>
                        <a className='r2-card2' href="#">
                            <img src="/Assets/FSimages/h2.webp" />
                        </a>
                        <a className='r2-card3' href="#">
                            <img src="/Assets/FSimages/h3.webp" />
                        </a>
                    </div>
                </div>

                <div className="fs-row3 fs-rows">
                    <h3>Roller - Roman - Panel Blinds</h3>
                    <div className="fs-r3-cards">
                        <a className='r3-card1' href="#">
                            <img src="/Assets/FSimages/r1.webp" />
                        </a>
                        <a className='r3-card2' href="#">
                            <img src="/Assets/FSimages/r2.webp" />
                        </a>
                        <a className='r3-card3' href="#">
                            <img src="/Assets/FSimages/r3.webp" />
                        </a>
                        <a className='r3-card4' href="#">
                            <img src="/Assets/FSimages/r4.webp" />
                        </a>
                        <a className='r3-card5' href="#">
                            <img src="/Assets/FSimages/r5.webp" />
                        </a>
                    </div>
                </div>

                <div className="fs-row4 fs-rows">
                    <div className="row4-c1">
                        <h3>Blackout</h3>
                        <a className='r4-cards' href="#">
                            <img src="/Assets/FSimages/b1.webp" />
                        </a>
                    </div>
                    <div className="row4-c2">
                        <h3>Translucent</h3>
                        <a className='r4-cards' href="#">
                            <img src="/Assets/FSimages/b2.webp" />
                        </a>
                    </div>
                    <div className="row4-c3">
                        <h3>Visible</h3>
                        <a className='r4-cards' href="#">
                            <img src="/Assets/FSimages/b3.webp" />
                        </a>
                    </div>
                </div>

                <div className="fs-row5 fs-rows">
                    <h3>Openness Factor</h3>
                    <a className='r5-cards' href="#">
                        <img src="/Assets/FSimages/os.webp" />
                    </a>
                </div>

                <div className="fs-row6 fs-rows">
                    <h3>WOODEN VENETIAN BLINDS</h3>
                    <div className="fs-row6-inner-rows">
                        <div className="r6-card1">
                            <h3>Russet Stain</h3>
                            <a className='r6-cards' href="#">
                                <img src="/Assets/FSimages/w1.webp" />
                            </a>
                        </div>
                        <div className="r6-card2">
                            <h3>Prosper Designer</h3>
                            <a className='r6-cards' href="#">
                                <img src="/Assets/FSimages/w2.webp" />
                            </a>
                        </div>
                    </div>
                    <div className="fs-row6-inner-rows">
                        <div className="r6-card4">
                            <a className='r6-cards' href="#">
                                <img src="/Assets/FSimages/w3.webp" />
                            </a>
                            <h3>Faux Metallic</h3>
                        </div>
                        <div className="r6-card4">
                            <a className='r6-cards' href="#">
                                <img src="/Assets/FSimages/w4.webp" />
                            </a>
                            <h3>Sable Plain</h3>
                        </div>
                    </div>
                </div>

                <div className="fs-row7 fs-rows">
                    <div className="r7-card1">
                        <h3>Patricia Blinds</h3>
                        <div className="row7-img-c">
                            <a className='r7-cards-img1' href="#">
                                <img src="/Assets/FSimages/k1.webp" />
                            </a>
                            <a className='r7-cards-img2' href="#">
                                <img src="/Assets/FSimages/k2.webp" />
                            </a>
                        </div>
                    </div>

                    <div className="r7-card2">
                        <h3>Luzon Blinds</h3>
                        <div className="row7-img-c">
                            <a className='r7-cards-img3' href="#">
                                <img src="/Assets/FSimages/k3.webp" />
                            </a>
                            <a className='r7-cards-img4' href="#">
                                <img src="/Assets/FSimages/k4.webp" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="fs-row8 fs-rows">
                    <h3>VISIBLE FABRICS</h3>
                    <div className="fs-r8-cards">
                        <a className='r8-card1' href="#">
                            <img src="/Assets/FSimages/v1.webp" />
                            <h3>I Best</h3>
                        </a>
                        <a className='r8-card2' href="#">
                            <img src="/Assets/FSimages/v2.webp" />
                            <h3>Meo</h3>
                        </a>
                        <a className='r8-card3' href="#">
                            <img src="/Assets/FSimages/v3.webp" />
                            <h3>Crystal</h3>
                        </a>
                        <a className='r8-card4' href="#">
                            <img src="/Assets/FSimages/v4.webp" />
                            <h3>Max</h3>
                        </a>
                        <a className='r8-card5' href="#">
                            <img src="/Assets/FSimages/v5.webp" />
                            <h3>Pleat</h3>
                        </a>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default FScontent;
